import axios from 'axios';

// const baseURL = 'BASEURL_TBD'; //process.env.REACT_APP_BACKEND_URL;
// const baseURL = process.env.REACT_APP_BACKEND_URL;
const baseURL = import.meta.env.VITE_BACKEND_URL;

if (!baseURL) {
  // Aide au debug si la variable n’est pas définie
  console.warn(
    "[Axios] VITE_BACKEND_URL est indéfini. Vérifie ton fichier .env et le préfixe VITE_."
  );
}

let headers: any = {};

if(localStorage.token) {
    headers.Authorization=`Bearer ${localStorage.token}`;
}

const axiosInstance = axios.create({
    baseURL: baseURL,
    headers,
});

export default axiosInstance;
